import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TabMenu } from "primereact/tabmenu";
import PageTitle from "../components/common/PageTitle";
import { AUTHORITIES } from "../constants";
import { hasRequiredAuthority } from "../utils";

export default function ManageTasks() {
    const navigate = useNavigate();
    const location = useLocation();
    const { authorities = [] } = useSelector((state) => state.stateUser);

    const showTabs = /\/user-tasks\/?(assigned|created|all)?$/.test(location.pathname);

    const items = useMemo(() => {
        const tabs = [
            { key: "assigned", label: "Assigned To Me", icon: "pi pi-inbox", command: () => navigate("/user-tasks/assigned") },
        ];
        if (hasRequiredAuthority(authorities, AUTHORITIES.CREATE_USER_TASK)) {
            tabs.push({ key: "created", label: "Created By Me", icon: "pi pi-pencil", command: () => navigate("/user-tasks/created") });
        }
        if (hasRequiredAuthority(authorities, AUTHORITIES.READ_ALL_USER_TASKS)) {
            tabs.push({ key: "all", label: "All Tasks", icon: "pi pi-list", command: () => navigate("/user-tasks/all") });
        }
        return tabs;
    }, [authorities, navigate]);

    const activeIndex = useMemo(() => {
        if (location.pathname.includes("/created")) return items.findIndex((t) => t.key === "created");
        if (location.pathname.includes("/all")) return items.findIndex((t) => t.key === "all");
        return items.findIndex((t) => t.key === "assigned");
    }, [items, location.pathname]);

    return (
        <div className="flex flex-column h-full overflow-hidden">
            <PageTitle title="Tasks" />
            {showTabs ? (
                <div className="overflow-x-auto flex-shrink-0">
                    <TabMenu
                        model={items}
                        activeIndex={Math.max(activeIndex, 0)}
                        pt={{
                            root: { className: "min-w-max" },
                            menu: { className: "flex-nowrap white-space-nowrap" },
                            action: { className: "white-space-nowrap" },
                        }}
                    />
                </div>
            ) : null}
            <div className="flex-1 min-h-0 overflow-hidden flex flex-column">
                <Outlet />
            </div>
        </div>
    );
}
